import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  AspectRatio,
  VStack,
  Badge,
  Flex,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

// ─── Brand tokens ────────────────────────────────────────────────────────────
const brand = {
  deep: "#024856",
  primary: "#007188",
  light: "#5AB3C5",
  pale: "#E9F0F1",
};

// ─── Types ───────────────────────────────────────────────────────────────────
interface VideoItem {
  id: string;
  youtubeId: string;
  title: string;
  description?: string;
  tag?: string;
}

// ─── Data ────────────────────────────────────────────────────────────────────
const videos: VideoItem[] = [
  {
    id: "1",
    youtubeId: "ncLiRr1lbXc",
    title: "Wobble időpontfoglaló rendszer - regisztráció",
    description:
      "Ebben a videóban lépésről lépésre bemutatom, hogyan tudsz regisztrálni a Wobble időpontfoglaló rendszerbe. ",
    tag: "Regisztráció",
  },
  {
    id: "2",
    youtubeId: "Fp95GLlS9QE",
    title: "Wobble időpontfoglaló rendszer - Foglalási oldal beállítása",
    description:
      "Ebben a videóban megmutatjuk, hogyan tudod pillanatok alatt beállítani és saját igényeidre szabni a foglalási oldaladat.",
    tag: "Foglalási oldal",
  },
  {
    id: "3",
    youtubeId: "dkBh00xtlF0",
    title: "Egyéni és csoportos szolgáltatás létrehozása a Wobble-ben | Lépésről lépésre útmutató | új |",
    description:
      "Ebben a demo videóban végigvezetlek azon a folyamaton, hogyan tudsz szolgáltatást létrehozni a Wobble időpontfoglaló rendszerben.",
    tag: "Szolgáltatás létrehozása",
  },
  {
    id: "4",
    youtubeId: "sngnsl7X8Cg",
    title: "Időpontok beállítása - Wobble időpontfoglaló",
    description:
      "Fedezd fel, hogyan állíthatod be villámgyorsan az időpontokat a Wobble időpontfoglaló rendszerében! ",
    tag: "Időpontok",
  },
  {
    id: "5",
    youtubeId: "UcTDtr6daUg",
    title: "Kategóriák létrehozása a Wobble-ben – lépésről lépésre",
    description:
      "Új Wobble funkció: kategóriák, amikkel még átláthatóbb lesz a foglalási oldalad! Szeretnéd, ha a szolgáltatásaid rendezettebben, átláthatóbban jelennének meg?",
    tag: "Kategóriák",
  },
  {
    id: "6",
    youtubeId: "582oLOqi3IA",
    title: "Wobble weboldal beállítások – Lépésről lépésre",
    description:
      "Ebben a videóban megmutatjuk, hogyan tudod egyszerűen és gyorsan beállítani a weboldaladat a Wobble rendszerben. ",
    tag: "Weboldal",
  },
  {
    id: "7",
    youtubeId: "sngnsl7X8Cg",
    title: "Hogyan állítsd be a számlázást a Wobble-ben? | Billingo és Számlázz.hu integráció lépésről lépésre",
    description:
      "Fedezd fel, hogyan állíthatod be villámgyorsan az időpontokat a Wobble időpontfoglaló rendszerében! ",
    tag: "Időpontok",
  },
  {
    id: "8",
    youtubeId: "NJB-V868_hc",
    title: "Kérdőívek létrehozása a Wobble időpontfoglaló rendszerében – Ismerd meg ügyfeleid előre!",
    description:
      "Nézd meg, hogyan készíthetsz kérdőíveket a Wobble rendszerében, hogy már az időpont előtt minél többet megtudhass ügyfeleidről!",
    tag: "Kérdőív",
  },
  {
    id: "9",
    youtubeId: "5RLeiJloZ5I",
    title: "MyWobble ügyfélfiók létrehozása",
    description:
      "Visszatérő vendégeidnek könnyítsd meg az időpontfoglalást és az időpontok kezelését! Azért hoztuk létre a MyWobble ügyfélfiókot, hogy lerövidítsük a foglalási időt, ",
    tag: "MyWobble",
  },
  {
    id: "10",
    youtubeId: "5rlbLDw15vY",
    title: "Wobble email marketing használata - lépésről lépésre",
    description:
      "Ismerd meg, hogyan működik a Wobble időpontfoglaló rendszer e-mail marketing funkciója! ",
    tag: "Email",
  },
  {
    id: "11",
    youtubeId: "KEjMF7iJ-6s",
    title: "Hogyan készíts és kezeld blogbejegyzéseidet a Wobble rendszerében",
    description:
      "Ebben a videóban bemutatjuk, hogyan hozhatsz létre, szerkeszthetsz és tehetsz közzé blogbejegyzéseket a Wobble rendszerében. ",
    tag: "Blog",
  },
  {
    id: "12",
    youtubeId: "4u_SJNsBOFY",
    title: "Várólista beállítása a Wobble időpontfoglaló rendszerében – lépésről lépésre",
    description:
      "Fedezd fel, hogyan működik a várólista a Wobble időpontfoglaló rendszerében! ",
    tag: "Várólista",
  },
  {
    id: "13",
    youtubeId: "q--YERr1IUk",
    title: "Wobble naptár – így kezeld egyszerűen a foglalásaidat",
    description:
      "Fedezd fel, milyen egyszerűen és gyorsan kezelheted a foglalásaidat a Wobble naptárban!",
    tag: "Naptár",
  },
  {
    id: "14",
    youtubeId: "CeCvhvohUyw",
    title: "Wobble előfizetés beállítása",
    description:
      "Szeretnéd egyszerűen beállítani a Wobble előfizetésed? Ebben a videóban lépésről lépésre bemutatom, hogyan működik az előfizetés a rendszerben:",
    tag: "Előfizetés",
  },
];

const VideoCard = ({ video }: { video: VideoItem }) => (
  <Box
    role="group"
    borderRadius="2xl"
    overflow="hidden"
    bg="white"
    boxShadow="0 2px 12px rgba(2,72,86,0.08)"
    transition="all 0.35s cubic-bezier(0.4,0,0.2,1)"
    _hover={{
      transform: "translateY(-6px)",
      boxShadow: `0 20px 40px rgba(2,72,86,0.16)`,
    }}
  >
    {/* Thumbnail / embed */}
    <Box position="relative">
      <AspectRatio ratio={16 / 9}>
        <Box
          as="iframe"
          title={video.title}
          src={`https://www.youtube.com/embed/${video.youtubeId}?rel=0&modestbranding=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          style={{ border: 0 }}
        />
      </AspectRatio>
    </Box>

    {/* Card body */}
    <Box p={5}>
      {video.tag && (
        <Badge
          mb={2}
          px={3}
          py={1}
          borderRadius="full"
          fontSize="0.65rem"
          fontWeight="700"
          letterSpacing="0.08em"
          textTransform="uppercase"
          color="white"
          bg={brand.primary}
        >
          {video.tag}
        </Badge>
      )}

      <Heading
        as="h3"
        fontSize={{ base: "md", md: "lg" }}
        fontWeight="700"
        color={brand.deep}
        lineHeight="1.3"
        mb={2}
        fontFamily="'Lora', Georgia, serif"
        _groupHover={{ color: brand.primary }}
        transition="color 0.2s"
      >
        {video.title}
      </Heading>

      {video.description && (
        <Text fontSize="sm" color="gray.500" lineHeight="1.65" noOfLines={2}>
          {video.description}
        </Text>
      )}
    </Box>
  </Box>
);

// ─── Page component ───────────────────────────────────────────────────────────
const PAGE_TITLE = "Wobble videótár — Nézd meg és kezd el még ma";
const PAGE_SUBTITLE =
  "Nem vagy biztos benne, mit kapsz? Megmutatjuk. Videóinkban lépésről lépésre végigvezetünk a Wobble időpontfoglaló rendszerén, így azonnal látni fogod, mennyire egyszerű használni.";
const CANONICAL_URL = "https://yoursite.com/videos"; // ← update per project

const VideoPage = () => {
  return (
    <>
      {/* ── SEO ─────────────────────────────────────────────────────────── */}
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_SUBTITLE} />
        <link rel="canonical" href={CANONICAL_URL} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_SUBTITLE} />
        <meta property="og:url" content={CANONICAL_URL} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_SUBTITLE} />

        {/* Structured data — VideoObject list */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: PAGE_TITLE,
            description: PAGE_SUBTITLE,
            url: CANONICAL_URL,
            hasPart: videos.map((v) => ({
              "@type": "VideoObject",
              name: v.title,
              description: v.description ?? v.title,
              embedUrl: `https://www.youtube.com/embed/${v.youtubeId}`,
              url: `https://www.youtube.com/watch?v=${v.youtubeId}`,
            })),
          })}
        </script>

        {/* Google Font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Lora:wght@500;700&family=DM+Sans:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <Box
        as="main"
        minH="100vh"
        bg={brand.pale}
        fontFamily="'DM Sans', sans-serif"
      >
        <Box
          as="header"
          position="relative"
          overflow="hidden"
          bg={brand.deep}
          pt={{ base: 16, md: 24 }}
          pb={{ base: 20, md: 28 }}
        >
          <Box
            position="absolute"
            top="-120px"
            right="-80px"
            w="420px"
            h="420px"
            borderRadius="full"
            bg={brand.primary}
            opacity={0.18}
            pointerEvents="none"
          />
          <Box
            position="absolute"
            bottom="-160px"
            left="-60px"
            w="340px"
            h="340px"
            borderRadius="full"
            bg={brand.light}
            opacity={0.12}
            pointerEvents="none"
          />

          <Container maxW="4xl" position="relative" zIndex={1}>
            <VStack
              spacing={5}
              align={{ base: "center", md: "flex-start" }}
              textAlign={{ base: "center", md: "left" }}
            >
              <Flex align="center" gap={2}>
                <Box w="32px" h="2px" bg={brand.light} borderRadius="full" />
                <Text
                  fontSize="0.75rem"
                  fontWeight="700"
                  letterSpacing="0.14em"
                  textTransform="uppercase"
                  color={brand.light}
                >
                  Video Library
                </Text>
              </Flex>

              <Heading
                as="h1"
                fontSize={{ base: "3xl", sm: "4xl", md: "5xl", lg: "6xl" }}
                fontWeight="700"
                fontFamily="'Lora', Georgia, serif"
                color="white"
                lineHeight="1.1"
                letterSpacing="-0.02em"
              >
                Wobble útmutató {" "}
                <Box
                  as="span"
                  color={brand.light}
                  position="relative"
                  _after={{
                    content: '""',
                    position: "absolute",
                    bottom: "-4px",
                    left: 0,
                    width: "100%",
                    height: "3px",
                    bg: brand.light,
                    borderRadius: "full",
                    opacity: 0.5,
                  }}
                >
                  videók
                </Box>
              </Heading>

              <Heading
                as="h2"
                fontSize={{ base: "md", md: "xl" }}
                fontWeight="400"
                color="whiteAlpha.700"
                maxW="600px"
                lineHeight="1.6"
              >
                {PAGE_SUBTITLE}
              </Heading>

              <Flex
                mt={4}
                gap={8}
                wrap="wrap"
                justify={{ base: "center", md: "flex-start" }}
              >
                {[
                  { value: `${videos.length}`, label: "Videó" },
                  { value: "Útmutató", label: "Típus" },
                  { value: "Ingyenes", label: "Megtekintés" },
                ].map((stat) => (
                  <Box key={stat.label} textAlign="center">
                    <Text
                      fontSize="2xl"
                      fontWeight="800"
                      color="white"
                      fontFamily="'Lora', serif"
                      lineHeight="1.5"
                    >
                      {stat.value}
                    </Text>
                    <Text
                      fontSize="xs"
                      color="whiteAlpha.600"
                      fontWeight="500"
                      letterSpacing="0.06em"
                      textTransform="uppercase"
                    >
                      {stat.label}
                    </Text>
                  </Box>
                ))}
              </Flex>
            </VStack>
          </Container>

          <Box
            position="absolute"
            bottom="-1px"
            left={0}
            right={0}
            lineHeight={0}
          >
            <svg
              viewBox="0 0 1440 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ display: "block" }}
            >
              <path
                d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H1380C1320 60 1200 60 1080 60C960 60 840 60 720 60C600 60 480 60 360 60C240 60 120 60 60 60H0Z"
                fill={brand.pale}
              />
            </svg>
          </Box>
        </Box>

        <Container maxW="7xl" px={{ base: 4, md: 8 }} py={{ base: 12, md: 16 }}>
          <SimpleGrid
            as="section"
            aria-label="Video collection"
            columns={{ base: 1, sm: 2, lg: 3 }}
            spacing={{ base: 6, md: 8 }}
          >
            {videos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </SimpleGrid>
        </Container>
      </Box>
    </>
  );
};

export default VideoPage;
